import axiosInstance from "api/axiosInstance"
import { itemCategoryAction } from "./item-category-slice"
import { batch } from "react-redux"
import SAlert from "components/Alert"
import exportAxiosInstance from "api/exportAxiosInstance"
import FileSaver from "file-saver"

export const getItemCategories =
  (
    url,
    pageNumber = 10,
    according = { order: "desc", name: "id" },
    search = null
  ) =>
  dispatch => {
    dispatch(itemCategoryAction.setLoading(true))
    url = url || "/v1/item-categories"
    axiosInstance
      .get(url, {
        params: {
          pageNumber: pageNumber,
          according: according,
          search: search,
        },
      })
      .then(response => {
        if (response) {
          batch(() => {
            dispatch(itemCategoryAction.setError(null))
            dispatch(itemCategoryAction.setData(response.data))
            dispatch(itemCategoryAction.setLoading(false))
          })
        }
      })
      .catch(error => {
        dispatch(itemCategoryAction.setLoading(false))
        console.log(error)
      })
  }

export const deleteItemCategory = id => dispatch => {
  dispatch(itemCategoryAction.setLoading(true))
  axiosInstance
    .delete(`/v1/item-categories/${id}`)
    .then(response => {
      batch(() => {
        dispatch(getItemCategories())
        SAlert({ title: "Success", text: "Item Category successfully deleted" })
        dispatch(itemCategoryAction.setError(null))
        dispatch(itemCategoryAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(itemCategoryAction.setLoading(false))
      console.log(error)
    })
}

export const storeItemCategory = (data, navigate) => dispatch => {
  dispatch(itemCategoryAction.setLoading(true))
  axiosInstance
    .post("/v1/item-categories", data)
    .then(response => {
      navigate("/item-categories")
      SAlert({ title: "Success", text: "Item Category successfully inserted" })
      batch(() => {
        dispatch(itemCategoryAction.setError(null))
        dispatch(itemCategoryAction.setLoading(false))
      })
    })
    .catch(err => {
      dispatch(itemCategoryAction.setLoading(false))
      dispatch(itemCategoryAction.setError(err?.response?.data?.errors))
    })
}

export const updateItemCategory = (id, data, navigate) => dispatch => {
  dispatch(itemCategoryAction.setLoading(true))
  axiosInstance
    .put(`/v1/item-categories/${id}`, data)
    .then(respnose => {
      navigate("/item-categories")
      SAlert({ title: "Success", text: "Item Category successfully updated" })
      batch(() => {
        dispatch(itemCategoryAction.setError(null))
        dispatch(itemCategoryAction.setLoading(false))
      })
    })
    .catch(error => {
      dispatch(itemCategoryAction.setLoading(false))
      dispatch(itemCategoryAction.setError(error?.response?.data?.errors))
    })
}

export const getByIdItemCategory = id => dispatch => {
  dispatch(itemCategoryAction.setLoading(true))
  axiosInstance
    .get(`/v1/item-categories/${id}`)
    .then(respnose => {
      batch(() => {
        dispatch(itemCategoryAction.setError(null))
        dispatch(itemCategoryAction.setLoading(false))
        dispatch(itemCategoryAction.setItemCategory(respnose.data))
      })
    })
    .catch(error => {
      dispatch(itemCategoryAction.setLoading(false))
      console.log(error)
    })
}

export const exportItemCategories = search => dispatch => {
  dispatch(
    itemCategoryAction.setExportStatus({
      loading: true,
      error: null,
    })
  )
  exportAxiosInstance
    .get("/v1/item-categories-export", {
      params: { search },
    })
    .then(response => {
      if (response) {
        const dataBlob = new Blob([response?.data], {
          type: "application/pdf,",
        })
        FileSaver.saveAs(
          dataBlob,
          `Item-Categories-${Math.random().toString()}.xlsx`
        )
        dispatch(
          itemCategoryAction.setExportStatus({
            loading: false,
            error: null,
          })
        )
      }
    })
    .catch(error => {
      dispatch(
        itemCategoryAction.setExportStatus({
          loading: false,
          error: error?.response?.errors,
        })
      )
      console.log(error)
    })
}
